module.exports = __webpack_public_path__ + "static/img/pharmaceuticalEnterprises3.81226b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Parters/pharmaceuticalEnterprises3.png
// module id = wLqg
// module chunks = 1